import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const paymentRequestBusinessObjectEnum = createEnum({
    VEHICLE: ['vehicle', '车辆业务', 'blue'],
    NON_VEHICLE: ['non_vehicle', '非车辆业务', 'default'],
});
export const PAYMENT_REQUEST_BUSINESS_OBJECTS = enumValues(paymentRequestBusinessObjectEnum);
export const PAYMENT_REQUEST_BUSINESS_OBJECT_LABEL_MAP = enumLabelMap(paymentRequestBusinessObjectEnum);
export const paymentRequestStatusEnum = createEnum({
    DRAFT: ['draft', '草稿', 'default'],
    REVIEWING: ['reviewing', '审核中', 'processing'],
    REVIEW_REJECTED: ['review_rejected', '审核拒绝', 'red'],
    PAYING: ['paying', '付款中', 'orange'],
    FULLY_PAID: ['fully_paid', '全部付款', 'cyan'],
    PARTIALLY_PAID: ['partially_paid', '部分付款', 'blue'],
    PAYMENT_REJECTED: ['payment_rejected', '拒绝付款', 'red'],
});
export const PAYMENT_REQUEST_STATUSES = enumValues(paymentRequestStatusEnum);
export const PAYMENT_REQUEST_STATUS_LABEL_MAP = enumLabelMap(paymentRequestStatusEnum);
export const paymentRequestActionEnum = createEnum({
    DRAFT: ['draft', '保存草稿', 'default'],
    SUBMIT: ['submit', '提交', 'blue'],
});
export const PAYMENT_REQUEST_ACTIONS = enumValues(paymentRequestActionEnum);
//# sourceMappingURL=payment-request.js.map